import { useEffect, useState } from "react";
import { GetMemberLoginById } from "../../_services";
import Layout from "../shared/Layout"

const MyProfile = () => {
    const [loginDetailById, setLoginDetailById] = useState([]);
    const [error, setError] = useState(null);
    // const [loading, setLoading] = useState(false);

    const fetchLoginDetailByLoginId = async () => {
        try {
            const data = await GetMemberLoginById();
            if (data.isSuccess === 200) {
                setLoginDetailById(data.data[0]);
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        }
    };

    useEffect(() => {
        fetchLoginDetailByLoginId();
    }, []);

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-4 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <span className="admin_profile_icon"> <img src="./images/gray-user-profile-icon.png" alt="" /></span>
                        <h4 className="mb-0">
                            My Profile
                        </h4>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="datatable mt-3 col-xxl-4 col-xl-4 col-lg-6 col-md-8 col-sm-10 col-12 user_profile_admin_data text-center">
                        <span className="profile_icon_image">
                        <i class="fa fa-pencil"></i>
                            <img src="./images/gray-user-profile-icon.png" alt="" />
                        </span>
                        <div>
                            <h4 className="my-2">{loginDetailById?.name}</h4>
                            <span>{loginDetailById?.emailId}</span>
                            <p className="my-2">{loginDetailById?.mobileNo}</p>
                        </div>

                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default MyProfile;